import { Box, Container, Grid, Card, CardActionArea, CardContent, CardMedia, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import aeograph from 'assets/images/blog/aeograph.png';
import Header from 'layout/CommonLayout/Header';

// ==============================|| BLOG PAGE ||============================== //

const BlogPage = () => {
  const theme = useTheme();

  const articles = [
    {
      id: 1,
      title: 'Beyond SEO: A Deep Dive into Answer Engine Optimization (AEO)',
      description: 'A full analysis of Answer Engine Optimization (AEO) based on Josh Blyskal\'s talk at BrightonSEO. Learn why AEO is not SEO and discover actionable strategies to win in AI search.',
      image: aeograph,
      date: 'June 7, 2025',
      author: 'Vlad Rimo',
      category: 'Industry Insights',
      slug: 'answer-engine-optimization-aeo'
    }
  ];

  return (
    <Box>
      <Header />
      {/* Hero Section */}
      <Box
        sx={{
          pt: { xs: 8, md: 12 },
          pb: { xs: 6, md: 8 },
          bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'grey.50'
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h1" gutterBottom>
            Blog
          </Typography>
          <Typography variant="h4" color="textSecondary" sx={{ maxWidth: '800px' }}>
            Insights, tutorials, and industry analysis to help you stay ahead in the digital landscape.
          </Typography>
        </Container>
      </Box>

      {/* Articles Grid */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Grid container spacing={4}>
          {articles.map((article) => (
            <Grid item xs={12} sm={6} md={4} key={article.id}>
              <Card 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <CardActionArea component={Link} to={`/blog/${article.slug}`}>
                  <CardMedia
                    component="img"
                    height="240"
                    image={article.image}
                    alt={article.title}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="overline" color="primary" gutterBottom>
                      {article.category}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                      {article.title}
                    </Typography>
                    <Typography variant="body1" color="textSecondary" paragraph>
                      {article.description}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                      <Typography variant="subtitle2" color="textSecondary">
                        {article.date}
                      </Typography>
                      <Typography variant="subtitle2" color="textSecondary">
                        By {article.author}
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default BlogPage; 